import React from 'react';
import renderImageNode from '../../common/renderImageNode.js';
import renderTitleNode from '../../common/renderTitleNode.js';
import img from '../../image/network-error.png.js';
import '../../style/index.less.js';
import useLanguage from '../../../hooks/useLangugle/index.js';

var Empty = function Empty(props) {
  var ExceptionLocale = useLanguage('Exception');
  var _a = props.image,
    image = _a === void 0 ? img : _a,
    _b = props.title,
    title = _b === void 0 ? ExceptionLocale['networkError'] : _b;
  return /*#__PURE__*/React.createElement("div", {
    className: "ti-exception"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-exception-image"
  }, renderImageNode(image)), /*#__PURE__*/React.createElement("div", {
    className: "ti-exception-title"
  }, renderTitleNode(title)));
};

export { Empty as default };
